// extracted by mini-css-extract-plugin
export default {"carousel":"SocialSlider_carousel__38Jq3","card":"SocialSlider_card__4LajB","active":"SocialSlider_active__n4Eu9"};